module.exports = __webpack_public_path__ + "static/img/solution5.3f519a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/solution5.jpg
// module id = mZOr
// module chunks = 9